module.exports = __webpack_public_path__ + "static/img/verifiy-fail.94e17dcc.png";